var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "loader-container fixed",
          class: { "from-header": _vm.isheader }
        },
        [
          _c("div", { staticClass: "loader-inner-container fixed" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.message
              ? _c(
                  "div",
                  {
                    staticClass:
                      "loader-message-container mt15 py5 px15 align-center h6 cl-white"
                  },
                  [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]
                )
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner relative" }, [
      _c("div", {
        staticClass:
          "double-bounce1 absolute w-100 brdr-circle bg-cl-th-success"
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "double-bounce2 absolute w-100 brdr-circle bg-cl-th-success"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }